/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CreateLeadCapturePopupCancelIcon from "../../../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg";
import CloseIcon from "../../../../../assets/icons/closeIcon.svg";
import "./create-lead-capture-popup-cancel.scss";

const CreateLeadCapturePopupCancel = (props: any) => {
   const {
        setIsShowCancelPopup,
        isShowCancelPopup,
        handleClosePreview
  } = props;

  return (
    <>
     <Dialog
        open={isShowCancelPopup}
        onClose={() => setIsShowCancelPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`create-lead-capture-popup-cancel`}
      >
        <DialogTitle id="alert-dialog-title">
            <div className="header-wrapper">
              <div className="image-wrapper">
                <img src={CreateLeadCapturePopupCancelIcon} className="delete-icon"></img>
                <img
                  src={CloseIcon}
                  className="close-icon"
                  onClick={() => setIsShowCancelPopup(false)}
                />
              </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="cancel-popup-text">
              You have unsaved form
            </div>
            <div className="cancel-popup-sub-text">
              Are you sure you want to cancel? Your changes will be lost.
            </div>
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsShowCancelPopup(false)} className="cancel-btn">
            No
          </Button>
          <Button onClick={handleClosePreview} autoFocus className="action-btn">
            Yes
          </Button>
        </DialogActions>
      </Dialog>          
    </>
  );
}

export default CreateLeadCapturePopupCancel;
